import BannerTopSlim from '@/components/domains/banners/BannerTopSlim'

export { BannerTopSlim }
